class SliderCollection extends HTMLElement {
  connectedCallback() {
    this._swipers = new Map();
    this.initPanelSwipers();

    this.querySelectorAll('.collection-button').forEach((btn) => {
      btn.addEventListener('click', () => {
        const handle = btn.dataset.collection;

        this.querySelectorAll('.collection-button').forEach((b) => {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        this.querySelectorAll('.collection-panel').forEach((panel) => {
          const show = panel.dataset.collectionPanel === handle;
          panel.toggleAttribute('hidden', !show);
          if (show) {
            const el = panel.querySelector('.swiper-collection');
            if (el && this._swipers.has(el)) {
              const swiper = this._swipers.get(el);
              swiper.update();
              this.updateNavigationVisibility(el);
            } else {
              this.initSwiper(el);
            }
          }
        });
      });
    });

    this.querySelectorAll('.product-card__add-btn').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const id = Number(btn.dataset.variantId);
        const qty = parseInt(btn.dataset.quantity || '1', 10);
        if (!id) return;

        btn.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: qty }] }),
          });

          if (!res.ok) {
            console.error('ADD ERROR', res.status, await res.text());
            return;
          }

          const cartRes = await fetch('/cart.js', {
            headers: { Accept: 'application/json' },
            cache: 'no-store',
          });
          const cart = await cartRes.json();

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          document.querySelector('side-cart')?.open?.();
        } catch (e) {
          console.error(e);
        } finally {
          btn.disabled = false;
        }
      });
    });
  }

  initPanelSwipers() {
    this.querySelectorAll('.swiper-collection').forEach((el) => this.initSwiper(el));
  }

  initSwiper(el) {
    if (!el) return;
    if (this._swipers.has(el)) return;

    const swiper = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 6,
      freeMode: {
        enabled: true,
        sticky: true,
        momentumRatio: 0.5,
      },
      mousewheel: {
        forceToAxis: true,
        thresholdDelta: 15,
        thresholdTime: 100,
        releaseOnEdges: true,
      },
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        990: { spaceBetween: 18 },
      },
      on: {
        init: () => {
          requestAnimationFrame(() => this.updateNavigationVisibility(el));
        },
        resize: () => this.updateNavigationVisibility(el),
      },
    });

    this._swipers.set(el, swiper);
  }

  updateNavigationVisibility(el) {
    const navigation = el.querySelector('.swiper-navigation');
    if (!navigation) return;

    requestAnimationFrame(() => {
      const bullets = el.querySelectorAll('.swiper-pagination-bullet');
      navigation.classList.toggle('swiper-navigation--hidden', bullets.length <= 1);
    });
  }
}

customElements.define('slider-collection', SliderCollection);
